
import { useState, useEffect } from "react"
import "../css/Lobbies.css";

import { useNavigate } from "react-router";


async function CallAPI(url, meth){

    const method = meth || "GET"
    const response = await fetch(
        `https://anagrams.ca/api/${url}`,
            {
            credentials: "include",
            method: method
            }
    );

    return response
}
export default function AnagramsLobby() {

    const navigate = useNavigate()
    const [games, setGames] = useState([]);

    const [profile, setProfile] = useState({});

    
    useEffect(() => {
        async function loadGameList() {
            const response = await CallAPI("anagrams/lobbies");
            const data = await response.json();

            setGames(data)
        }

        async function getProfile(){
        const response = await CallAPI("account/me");
        const data = await response.json();
            setProfile(data.profile);
        }
        loadGameList()
        getProfile();

        console.log('Logged in as: ' + profile);
        const int1 = setInterval(getProfile, 15000)
        const int2 = setInterval(loadGameList, 3000)
        return () => {
            clearInterval(int1);
            clearInterval(int2);
        };

    }, [])

    async function joinGameClick(gameId, user) {

        console.log('Joining Game')
        const username = profile.displayName

        if(!username){
            return
        }

        const response = await CallAPI(`anagrams/${gameId}/join?username=${username}`, "POST")

        const data = await response.json();
        if(!data[200]){
            return alert(data['error'])
            
        }

        navigate(`/anagramsMultiplayer`, {
            state: {
                gameId: gameId,
                username
            }
        });
        
    }

    async function createGame(){
        const username = profile.displayName


        if(!username){
            return;
        } 
        const response = await CallAPI(`anagrams/create?username=${username}`, "POST")


        const data = await response.json();

        if(data['error']){
            return alert(data['error']);
        }

        return await joinGameClick(data['gameId']);
    }

    return (
        <>
            <div className="Title">
                <h1>Multiplayer Anagrams Lobbies</h1>
            </div>
            <button className="createGameButton anagramsCGB" onClick={() => createGame()}>Create Game!</button>
            <div className="GameList">
                <PrintGames games={games} joinClick={joinGameClick} />
            </div>
        </>
    )
}


function PrintGames({ games, joinClick }) {
    
    console.log(games)
    return (
        <>
            {games.map((game) => {

            if(game.settings.maxPlayers == game.player_count){
                return null
            }
                return (
                    <div className="game" key={game.game_id}>
                        <div className="game-header">
                            <div className="game-info">
                                <p>
                                    <b>Game ID:</b> {game.game_id}
                                </p>

                                <p>
                                    <b>Players:</b> {game.player_count}
                                </p>
                            </div>

                            <button
                                className="join-btn"
                                onClick={() => joinClick(game.game_id)}
                            >
                                Join Game
                            </button>
                        </div>


                        <details>
                            <summary><b>Settings</b></summary>

                            <p className="indented">
                                <b>Max Players:</b> {game.settings.maxPlayers}
                            </p>

                            <p className="indented">
                                <b>Max Time:</b> {game.settings.maxTime}
                            </p>

                            <p className="indented">
                                <b>Letter Count:</b> {game.settings.letterCount}
                            </p>
                        </details>
                    </div>

                )
            })}

        </>
    )


}


function CreateGame({callback}){
    return (
    <>

    <button className="createGameButton"
        onClick={() => callback()}>
    </button>

    </>
        )
}

